module.exports = "/static/assets/54ae4ff5cb9eee86b2544af94992b91e.svg";